import VideoPlayer from "src/components/video-player/video-player";

function VideoPlayerIframe() {
  return <VideoPlayer />;
}

export default VideoPlayerIframe;
